import React, { useEffect, useRef } from 'react';
import './story.css';
import EditableText from '../../components/editable/EditableText';
import EditableImage from '../../components/editable/EditableImage';
import pastorAuntyImage from '../../assets/story/pastor_aunty.png';

const Story = () => {
  const contentRefs = useRef([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Intersection Observer to handle scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    contentRefs.current.forEach((ref) => {
      if (ref instanceof Element) { 
        observer.observe(ref);
      }
    });

    return () => observer.disconnect();
  }, []);

  const addToRefs = (el) => {
    if (el && !contentRefs.current.includes(el)) {
      contentRefs.current.push(el);
    }
  };

  return (
    <div className="story-container">
      {/* Fade-in animation on load */}
      <div className="story-background fade-in">
        <div className="story-overlay">
          <EditableText contentKey="story.hero.title" tag="h1" className="story-main-title">
            OUR STORY
          </EditableText>
        </div>
      </div>
      <div className="story-content scroll-animate" ref={addToRefs}>
        <EditableText contentKey="story.heading" tag="h2" className="story-heading">
          Who We Are
        </EditableText>
        <div className="decorative-divider"></div>

        <div className="story-description">
          <div className="story-text">
            <EditableText contentKey="story.p1" tag="p" className="story-paragraph" multiline>
              Welcome to our Malayalee Pentecostal Church in Philadelphia, serving the Indian Christian community with Spirit-filled worship, powerful sermons, and Malayalam services. If you're searching for a Malayalam church in Pennsylvania or a Pentecostal fellowship for Malayalees in America, we invite you to join our growing family in Christ.
            </EditableText>
            <EditableText contentKey="story.p2" tag="p" className="story-paragraph" multiline>
              We are a vibrant Malayalee-English Pentecostal Church located in Philadelphia, 
              established in September 2014 under the inspired leadership of our founding pastor, 
              Pr. Sajan George. As an ordained minister with the Assemblies of God – Penndel District USA, 
              Pr. George has been passionately guiding our church in its mission to grow spiritually and to 
              serve our community with faith, love, and purpose.
            </EditableText>
            <EditableText contentKey="story.p3" tag="p" className="story-paragraph" multiline>
              At our core, two unshakable principles bind us together: a deep love for Christ and an 
              unwavering commitment to fulfilling Jesus' calling upon mankind. This calling, known as the 
              Great Commission, compels us to share the transformative message of the Gospel with the world:
            </EditableText>
            <EditableText contentKey="story.quote1" tag="blockquote" className="story-quote" multiline>
              "Therefore go and make disciples of all nations, baptizing them in the name of the Father 
              and of the Son and of the Holy Spirit, and teaching them to obey everything I have commanded 
              you. And surely I am with you always, to the very end of the age." (Matthew 28:19-20)
            </EditableText>
            <EditableText contentKey="story.p4" tag="p" className="story-paragraph" multiline>
              Through worship, fellowship, and outreach, we strive to embody these words, making a difference 
              not only in our local community but wherever God leads us. Whether you are seeking a place to grow 
              in your faith, a family of believers to share life with, or a way to serve in God's kingdom, we welcome 
              you with open arms to be a part of this divine mission.
            </EditableText>
            <EditableText contentKey="story.quote2" tag="blockquote" className="story-quote" multiline>
              "I will build my church, and the gates of hell shall not prevail against it." (Matthew 16:18)
            </EditableText>
            <EditableText contentKey="story.p5" tag="p" className="story-paragraph" multiline>
              With this assurance, we continue to grow, serve, and glorify God, inviting you to join us on this 
              journey of faith. We hope your time with us is not just uplifting but life-changing. May God bless 
              you richly as we walk together in His grace and truth!
            </EditableText>
          </div>
          <div className="story-image-container scroll-animate" ref={addToRefs}>
            <EditableImage
              contentKey="story.pastor_image"
              src={pastorAuntyImage}
              alt="Pastor and Aunty"
              className="story-image"
            />
            <EditableText contentKey="story.image_title" tag="h3" className="image-title">
              Pr. Sajan George & Anie Sajan
            </EditableText>
          </div>
        </div>
      </div>
      
      {/* Our Mission Section */}
      <div className="mission-section scroll-animate" ref={addToRefs}>
        <EditableText contentKey="story.mission.title" tag="h2" className="mission-title">
          Our Mission
        </EditableText>
        <div className="mission-divider"></div>
        <EditableText contentKey="story.mission.description" tag="p" className="mission-description" multiline>
          PSAG's mission is to passionately serve God and others, spreading the gospel, fostering spiritual growth, 
          and bringing hope, healing, and transformation to individuals and communities through the power of Jesus Christ.
        </EditableText>
      </div>
    </div>
  );
};

export default Story;
